module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_document_02.a1760023.svg";